class CustomAnalytics {
  clientThankYou(order) {
    this._trigger(order.campaign.pixels.campaign);

    if (order.campaign.pixels.campaign.custom !== order.campaign.pixels.global.custom) {
      this._trigger(order.campaign.pixels.global);
    }
  }

  _trigger(pixels) {
    if (pixels.custom) {
      window.dataLayer.push({ clientCustomId: pixels.custom }, { event: 'client-custom-tracking' });
    }
  }
}

export default new CustomAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/custom.js